<template>
  <div class="product-container">
    <h1>ЛэндингАйтэм</h1>
    <div class="landing-item-container" v-html="itemContent.content"></div>
    <!-- <p>{{ itemContent.content?.css }}</p> -->
  </div>
  <ServiceRequestModal :settings="settings" :item="landingRequestItem" v-if="landingRequestItem" />
</template>

<script>
// import ItemUniqueOption from '@/components/ItemUniqueOption';
// import ItemOption from '@/components/ItemOption';
import ServiceRequestModal from '@/components/ServiceRequestModal';
import { fixBodyPadding } from '@/utils/fixBodyPadding'
import { applySeoMeta } from '@/utils/seo'

export default {
  name: 'LandingItem',
  props: ['category', 'id'],
  components: { ServiceRequestModal },

  data() {
    return {
      item: undefined,
      upsaleItems: [],
      group: [],
      selectedPillType: "description",
      order: {
        count: 1,
        additionSelect: [],
        additionUSelect: []
      },

      itemImageEleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },
      itemCatalogEleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },
      itemCatalog2EleData: {
        pos: { top: 0, left: 0, x: 0, y: 0 },
        initialX: 0,
        sourceTargetClick: null,
        sourceTargetClickTime: null,
        isMouseDown: false, // Флаг для отслеживания состояния мыши для ele
      },

      itemContent: ""
      // itemContent: { html: "123", css: "345" }
    }
  },
  async mounted() {
    const landingURL = this.$route.params.url;
    await this.getLanding(landingURL);
    await this.fetchSettings();
    this.executeLandingItemScripts(this.itemContent.content);
    // await this.getItem();

    window.scrollTo(0, 0);
    window.$('.product-images a').fancybox();

    window.$('.preloader-page').removeClass('proccess-load')
    // await this.getItem();

    // window.scrollTo(0, 0);
    // window.$('.product-images a').fancybox();


    // Добавляем слушателя на событие нажатия кнопки в Корзину
    // const addToCartBtn = document.querySelector('.add-to-cart');
    // addToCartBtn.addEventListener('click', this.buy);

    // Добавляем слушателя на событие нажатия кнопки оформления Заявки
    // const leaveRequestBtn = document.querySelector('.leave-request');
    // leaveRequestBtn.addEventListener('click', this.toggleServiceRequestModal);
  },

  methods: {
    openReadMore(pillType) {
      this.selectedPillType = pillType;
      fixBodyPadding();
      this.$store.commit('setReadMoreOpen', true);
      window.$('body').addClass('no-scroll');
    },

    closeReadMore() {
      fixBodyPadding();
      this.$store.commit('setReadMoreOpen', false);
      window.$('body').removeClass('no-scroll');
    },

    fancyClick(e) {
      if (window.change) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    addCount(i) {
      if (i + this.order.count) {
        this.order.count = Math.max(this.order.count + i, 1)
      }
    },

    isHot(item) {
      return item.advanced && item.advanced.hot
    },

    selectOption({ item, status }) {
      if (!this.order.additionSelect) {
        this.order.additionSelect = []
      }
      if (status) {
        this.order.additionSelect.push(item)
      } else {
        let idx = this.order.additionSelect.findIndex(x => x.id == item.id);
        if (idx > -1) {
          this.order.additionSelect.splice(idx, 1)
        }
      }
    },

    selectuOption({ item, status }) {
      if (!this.order.additionUSelect) {
        this.order.additionUSelect = []
      }
      if (status) {
        this.order.additionUSelect.push(item)
      } else {
        let idx = this.order.additionUSelect.findIndex(x => x._id == item._id);
        if (idx > -1) {
          this.order.additionUSelect.splice(idx, 1)
        }
      }
    },

    getItemImage(item) {
      if (item.preview && item.preview.includes('https://')) {
        return item.preview
      }
      return item.preview ? `${window.location.protocol}//${window.location.host}${item.preview}` : ''
    },

    getDiscount(item) {
      return item.preview ? (1 - Math.max(item.price / item.price_old, 0)) * 100 | 0 : ''
    },

    categoryURL(item) {
      let category = this.categories.find(x => x.id == item.category);
      return category?.info?.url ? category.info.url : ''
    },

    buy() {
      console.log("buy")

      let idx = -1;
      idx = this.basked.findIndex(i => i.id === this.item.id);
      if (idx > -1) {
        // this.basked[idx].count += this.order.count;
        this.$store.commit(
          'replaceBuskedIndex',
          { index: idx, value: JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item))) }
        );
      } else {
        let item = JSON.parse(JSON.stringify(Object.assign({}, this.order, this.item)))
        this.$store.commit('addToBasked', item);
        this.$AddToCart(item)
      }
      this.toggleBusked()
      // fixBodyPadding();
      // window.$('body').addClass('no-scroll');
      // window.$('#quick_cart').addClass('opened');
      // window.$('.item-modal-wrapper-bg').addClass('is-visible');
    },

    toggleBusked() {
      fixBodyPadding();

      this.$store.commit('setBuskedOpen', !this.isBuskedOpen)

      this.$store.commit('setSearchOpen', false);
      this.$store.commit('setReadMoreOpen', false)

      window.$('.overlay-menu').removeClass('active');
      window.$('.open-nav').removeClass('is-visible');
      window.$('.show-menu-btn').removeClass('open');

      window.$('.personal-area-modal-wrapper-bg').removeClass('is-visible');
      window.$('.personal_area-sidebar').removeClass('opened');
      window.$('.login-trigger-item').removeClass('active');


      window.$('.cart-modal-wrapper-bg').toggleClass('is-visible');
      window.$('.quick-card-sticker-li').toggleClass('active');
      window.$('#quick_cart').toggleClass('opened');

      window.$('body').toggleClass('no-scroll');
    },
    toggleServiceRequestModal() {
      fixBodyPadding();

      window.$('#request-modal').modal('show');


      window.$('body').toggleClass('no-scroll');


    },

    getURLImage(image) {
      if (image && image.includes('https://')) {
        return image
      }
      return `${window.location.protocol}//${window.location.host}${image}`
    },

    async getItem() {
      this.group = [];
      try {
        const response = await fetch(`/public/item/${this.id}`);
        const data = await response.json();

        if (data.result) {
          this.item = data.result;
          this.$ViewItem(this.item);
          await this.getUpsaleItems();
        }

        if (data.group) {
          this.group = data.group;
        }

        if (data.error === 'not found') {
          this.$router.push({ name: 'NotFound' });
          return;
        }

        if (this.item && this.item.advanced) {
          applySeoMeta({
            title: this.item.advanced.meta_title || this.$dynamic(this.item, this.item.title, 'title'),
            description: this.item.advanced.meta_description || '',
            pageType: 'item',
            item: this.item,
            settings: this.$store.getters.getSettings
          });
        }
        console.log("item", this.item)
      } catch (error) {
        console.error("Error fetching item:", error);
      }
    },

    async getUpsaleItems() {
      if (this.upsale && this.upsale.length) {
        try {
          const response = await fetch(`/public/item`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ list: this.upsale.map(i => i.id) })
          });

          const data = await response.json();

          if (data.result) {
            this.upsaleItems = data.result;
          }
        } catch (error) {
          console.error("Error fetching upsale items:", error);
        }
      }
    },

    isTouchDevice() {
      return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    },

    mouseDownHandler(e, ref) {
      // Определяем элемент для нужного списка
      let scrollElement;
      let data;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }
      data.isMouseDown = true; // Устанавливаем флаг для активного списка
      data.sourceTargetClick = e.target;
      data.sourceTargetClickTime = new Date().getTime();
      data.pos = {
        left: scrollElement.scrollLeft,
        top: scrollElement.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      data.initialX = e.clientX;

      if (!this.isTouchDevice()) {
        scrollElement.style.userSelect = 'none';

        // Привязываем контекст для функций-обработчиков
        document.addEventListener('mousemove', (event) => this.mouseMoveHandler(ref, event));
        document.addEventListener('mouseup', (event) => this.mouseUpHandler(ref, event));
      }
    },

    mouseMoveHandler(ref, e) {
      let data;
      let scrollElement;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }

      if (!data.isMouseDown) return; // Проверяем состояние для конкретного списка

      // console.log("mouseMoveHandler");

      const dx = e.clientX - data.pos.x;
      const dy = e.clientY - data.pos.y;

      scrollElement.scrollTop = data.pos.top - dy;
      scrollElement.scrollLeft = data.pos.left - dx;
    },

    mouseUpHandler(ref, e) {
      let data;
      let scrollElement;

      switch (ref) {
        case 'itemCatalog2Ele':
          scrollElement = this.$refs.itemCatalog2Ele; // Ссылка на первый список
          data = this.itemCatalog2EleData; // Данные для первого списка
          break;
        case 'itemCatalogEle':
          scrollElement = this.$refs.itemCatalogEle; // Ссылка на подсписок
          data = this.itemCatalogEleData; // Данные для подсписка
          break;
        case 'itemImageEle':
          scrollElement = this.$refs.itemImageEle; // Пример, нужно убедиться, что у вас есть этот ref
          data = this.itemImageEleData; // Данные для элемента изображения (предположим, что у вас есть такая переменная)
          break;
        default:
          scrollElement = undefined;
          data = undefined;
          console.error(`Unknown ref: ${ref}`);
      }

      if (!data.isMouseDown) return;
      // console.log("mouseUpHandler");
      data.isMouseDown = false; // Сбрасываем флаг для конкретного списка

      const currentX = e.clientX;
      const xDifference = Math.abs(currentX - data.initialX);
      const now = new Date().getTime();

      if ((now - data.sourceTargetClickTime) < 500 && xDifference < 1) {
        let target = data.sourceTargetClick;
        while (target) {
          if (target.href) {
            if (scrollElement.classList.contains('image_list')) { break }
            this.$router.push(target.href.replaceAll(`${window.location.protocol}//${window.location.host}`, ""));
            break;
          }
          target = target.parentElement;
        }
      } else {
        document.addEventListener('click', this.preventClick, true);
      }
      // console.error("remove listeners")
      document.removeEventListener('mousemove', (event) => this.mouseMoveHandler(ref, event));
      document.removeEventListener('mouseup', (event) => this.mouseUpHandler(ref, event));
    },
    preventClick(e) {
      // console.log("preventClick");
      e.stopImmediatePropagation();  // Останавливаем любое событие клика
      e.preventDefault();  // Отменяем стандартное действие
      document.removeEventListener('click', this.preventClick, true);  // Удаляем этот обработчик после срабатывания
    },

    truncateText(text, maxLength = 500) {
      if (text) {
        return text.length <= maxLength ? text : text.slice(0, maxLength) + "...";
      }
      return "";
    },

    // Уникалньая логика LandingItem
    async getLanding(url) {
      console.log("getLanding")
      try {
        const response = await fetch("/public/page/find", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ url })
        });


        if (!response.ok) {
          throw new Error('Сетевая ошибка: ' + response.statusText);
        }

        const data = await response.json();


        this.itemContent = data.result;
        console.log(" this.itemContent", this.itemContent)
      } catch (error) {
        console.error('Ошибка при получении данных:', error);
      }
    },
    async fetchSettings() {
      const resp = await fetch('/public/settings');
      const data = await resp.json();
      if (data) {
        this.$store.commit('setSettings', data);
      }
    },

    executeLandingItemScripts(html) {
      // Создаём временный элемент
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Находим все теги <script>
      const scripts = tempDiv.querySelectorAll('script');

      scripts.forEach((script) => {
        // Выполняем содержимое каждого скрипта
        try {
          eval(script.innerHTML);
        } catch (error) {
          console.error('Error executing script:', error);
        }
      });
    }
  },

  computed: {
    menu_type() {
      return this.$store.getters.getSettings ? this.$store.getters.getSettings.menu_type : undefined
    },
    videos() {
      return this.item?.advanced?.videos?.length ? this.item.advanced.videos : undefined
    },
    consultant() {
      return this.settings && this.settings.consultant ? this.settings.consultant : false
    },
    categories() {
      return this.$store.getters.getCategories
    },
    settings() {
      return this.$store.getters.getSettings
    },
    options() {
      return this.item && this.item.advanced && this.item.advanced.options ? this.item.advanced.options : []
    },
    uOptions() {
      return this.item && this.item.advanced && this.item.advanced.uOption ? this.item.advanced.uOption : []
    },
    optionSettings() {
      return this.$store.getters.getOptionSettings ? this.$store.getters.getOptionSettings : []
    },
    ingredient() {
      return this.item?.advanced?.options?.ingredient ? this.item?.advanced?.options?.ingredient.map(id => (
        this.ingridients?.list?.find(x => x.id === id)
      )).filter(i => !!i).sort((a, b) => a.order - b.order) : []
    },
    ingridients() {
      return this.$store.getters.getOptions?.ingredient ? this.$store.getters.getOptions.ingredient : {}
    },
    itemPrice() {
      return this.item.price
    },
    addPrice() {
      return this.addition_price + this.addition_Uprice
    },
    price() {
      return this.order.count * (this.item.price + this.addition_price + this.addition_Uprice)
    },
    price_old() {
      return this.price + ((this.item.price_old - this.item.price) * this.order.count)
    },
    upsale() {
      return this.item && this.item.advanced && this.item.advanced.upsale ? this.item.advanced.upsale : []
    },
    addition_Uprice() {
      return this.order.additionUSelect.reduce((c, value) => value && value.price ? c + parseFloat(value.price) : c, 0)
    },
    addition_price() {
      return this.order.additionSelect.reduce((c, value) => value && value.price ? c + parseFloat(value.price) : c, 0)
    },
    basked() {
      return this.$store.state.busked
    },
    isHotItem() {
      return this.item && this.item.advanced && this.item.advanced.hot
    },
    isStock() {
      return this.item && this.item.stock
    },
    isCatalogMod() {
      return this.$store.getters.getSettings?.catalog_mod
    },
    readMoreOpen() {
      return this.$store.getters.getReadMoreOpen || false
    },

    shortItemDescription() {
      const fullDescription = this.$dynamic(this.item, this.item.description, 'description');
      const maxTextLength = 700;

      //Если приходить строка в виде ткста без тегов
      function isHtmlString(input) {
        const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlTagRegex.test(input);
      }

      if (!isHtmlString(fullDescription)) {
        return fullDescription.length > maxTextLength ?
          { html: "<p>" + fullDescription.slice(0, maxTextLength) + "..." + "<p>", isReadMore: true } :
          { html: "<p>" + fullDescription + "<p>", isReadMore: false };
      }
      //---------------------------------------------

      let resultHTML = "";
      let textLength = 0;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = fullDescription;

      let hasSplitTag = false;
      for (let child of tempDiv.children) {
        if (child.tagName.toLowerCase() === "split") {
          hasSplitTag = true;
          break;
        }
      }

      if (hasSplitTag) {
        for (let child of tempDiv.children) {
          if (child.tagName.toLowerCase() === "split") break;
          resultHTML += child.outerHTML;
        }
        return { html: resultHTML, isReadMore: true };
      }

      let firstChild = true;

      for (let child of tempDiv.children) {
        if (firstChild) {
          resultHTML += child.outerHTML;
          textLength += child.innerText?.length || 0;
          firstChild = false;
          if (textLength > maxTextLength) {
            return { html: resultHTML, isReadMore: true };
          }
          continue;
        }

        if (!child.innerText) {
          resultHTML += child.outerHTML;
          continue;
        }

        if (textLength + child.innerText.length <= maxTextLength) {
          resultHTML += child.outerHTML;
          textLength += child.innerText.length;
        } else {
          resultHTML += child.outerHTML;
          return { html: resultHTML, isReadMore: true };
        }
      }

      return { html: resultHTML, isReadMore: false };
    },
    shortItemCharacteristics() {
      const fullCharacteristics = this.$dynamic(this.item, this.item.advanced.text1, 'text1');

      const maxTextLength = 700;

      //Если приходить строка в виде ткста без тегов
      function isHtmlString(input) {
        const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
        return htmlTagRegex.test(input);
      }

      if (!isHtmlString(fullCharacteristics)) {
        return fullCharacteristics.length > maxTextLength ?
          { html: "<p>" + fullCharacteristics.slice(0, maxTextLength) + "..." + "<p>", isReadMore: true } :
          { html: "<p>" + fullCharacteristics + "<p>", isReadMore: false };
      }
      //---------------------------------------------

      let resultHTML = "";
      let textLength = 0;

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = fullCharacteristics;

      let hasSplitTag = false;
      for (let child of tempDiv.children) {
        if (child.tagName.toLowerCase() === "split") {
          hasSplitTag = true;
          break;
        }
      }

      if (hasSplitTag) {
        for (let child of tempDiv.children) {
          if (child.tagName.toLowerCase() === "split") break;
          resultHTML += child.outerHTML;
        }
        return { html: resultHTML, isReadMore: true };
      }

      let firstChild = true;

      for (let child of tempDiv.children) {
        if (firstChild) {
          resultHTML += child.outerHTML;
          textLength += child.innerText?.length || 0;
          firstChild = false;

          if (textLength > maxTextLength) {
            return { html: resultHTML, isReadMore: true };
          }
          continue;
        }

        if (!child.innerText) {
          resultHTML += child.outerHTML;
          continue;
        }

        if (textLength + child.innerText.length <= maxTextLength) {
          resultHTML += child.outerHTML;
          textLength += child.innerText.length;
        } else {
          resultHTML += child.outerHTML;
          return { html: resultHTML, isReadMore: true };
        }
      }

      return { html: resultHTML, isReadMore: false };
    },

    landingRequestItem() {
      return this.$store.getters.getLandingRequestItem || undefined;
    }

  },

  watch: {
    async id() {
      await this.getItem();
      this.order = {
        count: 1,
        additionSelect: [],
        additionUSelect: []
      };
      // window.$(`.category-panel-holder a.active`).removeClass('active');
      // window.$(`a[href="/catalog/${this.category}"]`).addClass('active');
      window.scrollTo(0, 0);
      window.$('.product-imagesss a').fancybox();
      // window.$('.frame-modal-wrapper-bg').on('click', function () {
      //   window.$(this).removeClass('is-visible');
      //   window.$('body').removeClass('no-scroll');

      //   window.$('.frame-modal-list .first-level-item .level-sub').removeClass('open-level');
      //   window.$('#sort_filter,#sorting,#category_panel,#quick_cart').removeClass('opened');
      //   return false;
      // });
    }
  }
}
</script>

<style scoped>
.label-pic {
  display: inline-block;
  height: 11px;
  margin-right: 3px;
  vertical-align: middle;
  position: relative;
  top: -1px;
  width: 11px;
  margin-top: 0;
}

.videoBox {
  text-align: center;
  position: relative;
  padding-left: 75%;
}

.videoBox video {
  max-width: 100%;
  max-height: 100%;
  z-index: 11;
  width: 100%;
  position: absolute;
  top: 0;
  right: 50%;
  transform: translate(50%, 0);
}

.panel-body .text {
  overflow: hidden;
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
}

.not-in-stock {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>